export class KeyCodes {
  'backspace' = 8;
  'tab' = 9;
  'enter' = 13;
  'shift' = 16;
  'ctrl' = 17;
  'alt' = 18;
  'pause/break' = 19;
  'caps_lock' = 20;
  'escape' = 27;
  'page_up' = 33;
  'page_down' = 34;
  'end' = 35;
  'home' = 36;
  'left_arrow' = 37;
  'up_arrow' = 38;
  'right_arrow' = 39;
  'down_arrow' = 40;
  'insert' = 45;
  'delete' = 46;
  'left_window_key' = 91;
  'right_window_key' = 92;
  'select_key' = 93;
  'numpad_0' = 96;
  'numpad_1' = 97;
  'numpad_2' = 98;
  'numpad_3' = 99;
  'numpad_4' = 100;
  'numpad_5' = 101;
  'numpad_6' = 102;
  'numpad_7' = 103;
  'numpad_8' = 104;
  'numpad_9' = 105;
  'multiply' = 106;
  'add' = 107;
  'subtract' = 109;
  'decimal_point' = 110;
  'divide' = 111;
  'f1' = 112;
  'f2' = 113;
  'f3' = 114;
  'f4' = 115;
  'f5' = 116;
  'f6' = 117;
  'f7' = 118;
  'f8' = 119;
  'f9' = 120;
  'f10' = 121;
  'f11' = 122;
  'f12' = 123;
  'num_lock' = 144;
  'scroll_lock' = 145;
  'semi-colon' = 186;
  'equal_sign' = 187;
  ',' = 188; // "comma";
  '-' = 189; // "dash";
  '.' = 190; // "period";
  '/' = 191; // "forward slash";
  '`' = 192; // "grave accent";
  '[' = 219; // "open bracket";
  '\\' = 220; // "back slash";
  ']' = 221; // "close braket";
  "'" = 222; // "single quote"
}
